import { createSlice } from '@reduxjs/toolkit'

export const snackSlice = createSlice({
  name: 'snack',
  initialState: {},
  reducers: {
    messageFetched: (state, { payload }) => payload,
  },
})

export default snackSlice.reducer

export const {
  messageFetched,
} = snackSlice.actions

export const success = (text, options = {}) => (dispatch) => {
  dispatch(messageFetched({ text, variant: 'success', ...options }))
}
export const failed = (text, options = {}) => (dispatch) => {
  dispatch(messageFetched({ text, variant: 'error', ...options }))
}
export const info = (text, options = {}) => (dispatch) => {
  dispatch(messageFetched({ text, variant: 'info', ...options }))
}
export const warning = (text, options = {}) => (dispatch) => {
  dispatch(messageFetched({ text, variant: 'warning', ...options }))
}
export const defaultSnack = (text, options = {}) => (dispatch) => {
  dispatch(messageFetched({ text, variant: 'default', ...options }))
}
